(function() {
  'use strict';

  if (typeof window.noUiSlider === 'undefined') {
    return;
  }

  function formatMoney(value, moneyFormat) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(value * 100, moneyFormat || theme.settings.moneyFormat);
    }
    return 'R$ ' + Math.round(value).toLocaleString('pt-BR');
  }

  function initPriceSlider(priceRangeEl, isMobile) {
    if (!priceRangeEl) return null;

    var sliderEl = priceRangeEl.querySelector(isMobile 
      ? '.collection-dynamic-filters__mobile-price-slider' 
      : '.collection-dynamic-filters__price-slider');
    
    if (!sliderEl) return null;

    if (sliderEl.noUiSlider) {
      sliderEl.noUiSlider.destroy();
    }

    var minInput = priceRangeEl.querySelector(isMobile
      ? '.collection-dynamic-filters__mobile-price-input--min'
      : '.collection-dynamic-filters__price-input--min');
    
    var maxInput = priceRangeEl.querySelector(isMobile
      ? '.collection-dynamic-filters__mobile-price-input--max'
      : '.collection-dynamic-filters__price-input--max');

    if (!minInput || !maxInput) return null;

    var minRange = parseFloat(priceRangeEl.dataset.min) || 0;
    var maxRange = parseFloat(priceRangeEl.dataset.max) || 1000;
    
    var currentMinValue = minInput.value !== '' ? parseFloat(minInput.value) : null;
    var currentMaxValue = maxInput.value !== '' ? parseFloat(maxInput.value) : null;
    
    var sliderMinValue, sliderMaxValue;
    var isActive = false;
    
    if (currentMinValue !== null && !isNaN(currentMinValue) && currentMaxValue !== null && !isNaN(currentMaxValue)) {
      sliderMinValue = currentMinValue;
      sliderMaxValue = currentMaxValue;
      isActive = true;
    } else {
      sliderMinValue = minRange;
      sliderMaxValue = maxRange;
      isActive = false;
      if (minInput) {
        minInput.value = '';
        minInput.removeAttribute('value');
      }
      if (maxInput) {
        maxInput.value = '';
        maxInput.removeAttribute('value');
      }
    }

    if (isNaN(sliderMinValue) || sliderMinValue < minRange) sliderMinValue = minRange;
    if (isNaN(sliderMaxValue) || sliderMaxValue > maxRange) sliderMaxValue = maxRange;

    var displayMin = priceRangeEl.querySelector(isMobile
      ? '.collection-dynamic-filters__mobile-price-slider-min'
      : '.collection-dynamic-filters__price-slider-min');
    
    var displayMax = priceRangeEl.querySelector(isMobile
      ? '.collection-dynamic-filters__mobile-price-slider-max'
      : '.collection-dynamic-filters__price-slider-max');

    var slider = noUiSlider.create(sliderEl, {
      connect: true,
      start: [sliderMinValue, sliderMaxValue],
      range: {
        min: minRange,
        max: maxRange
      },
      step: 1,
      tooltips: false,
      behaviour: 'drag',
      drag: true
    });

    var userInteracted = isActive;

    slider.on('update', function(values) {
      var val1 = parseFloat(values[0]);
      var val2 = parseFloat(values[1]);
      var min = Math.round(Math.min(val1, val2));
      var max = Math.round(Math.max(val1, val2));

      if (userInteracted || isActive) {
        if (minInput) {
          minInput.value = min;
          minInput.setAttribute('value', min);
          minInput.removeAttribute('data-empty');
        }
        if (maxInput) {
          maxInput.value = max;
          maxInput.setAttribute('value', max);
          maxInput.removeAttribute('data-empty');
        }
      }

      if (displayMin) {
        displayMin.textContent = formatMoney(min);
      }
      if (displayMax) {
        displayMax.textContent = formatMoney(max);
      }
    });

    slider.on('start', function() {
      userInteracted = true;
    });

    slider.on('change', function(values) {
      var val1 = parseFloat(values[0]);
      var val2 = parseFloat(values[1]);
      var min = Math.round(Math.min(val1, val2));
      var max = Math.round(Math.max(val1, val2));

      if (userInteracted || isActive) {
        if (minInput) {
          minInput.value = min;
          minInput.setAttribute('value', min);
          minInput.removeAttribute('data-empty');
        }
        if (maxInput) {
          maxInput.value = max;
          maxInput.setAttribute('value', max);
          maxInput.removeAttribute('data-empty');
        }

        if (userInteracted) {
          if (minInput) {
            var changeEvent = new Event('change', { bubbles: true });
            minInput.dispatchEvent(changeEvent);
          }
          if (maxInput) {
            var changeEvent = new Event('change', { bubbles: true });
            maxInput.dispatchEvent(changeEvent);
          }
        }
      }
    });

    var syncSliderToInputs = function() {
      var currentValues = slider.get();
      var val1 = parseFloat(currentValues[0]);
      var val2 = parseFloat(currentValues[1]);
      var min = Math.round(Math.min(val1, val2));
      var max = Math.round(Math.max(val1, val2));

      if (userInteracted || isActive) {
        if (minInput) {
          minInput.value = min;
          minInput.setAttribute('value', min);
          minInput.removeAttribute('data-empty');
        }
        if (maxInput) {
          maxInput.value = max;
          maxInput.setAttribute('value', max);
          maxInput.removeAttribute('data-empty');
        }
      } else {
        if (minInput) {
          minInput.value = '';
          minInput.removeAttribute('value');
        }
        if (maxInput) {
          maxInput.value = '';
          maxInput.removeAttribute('value');
        }
      }
    };

    var applyButton = priceRangeEl.querySelector(isMobile
      ? '.collection-dynamic-filters__mobile-price-apply-btn'
      : '.collection-dynamic-filters__price-apply-btn');
    
    if (applyButton) {
      applyButton.addEventListener('click', function(e) {
        syncSliderToInputs();
        
        setTimeout(function() {
          if (minInput) {
            var changeEvent = new Event('change', { bubbles: true, cancelable: true });
            minInput.dispatchEvent(changeEvent);
          }
          if (maxInput) {
            var changeEvent = new Event('change', { bubbles: true, cancelable: true });
            maxInput.dispatchEvent(changeEvent);
          }
        }, 5);
      }, true);
    }

    return slider;
  }

  function initAllPriceSliders() {
    var desktopPriceRanges = document.querySelectorAll('.collection-dynamic-filters__price-range');
    desktopPriceRanges.forEach(function(priceRange) {
      initPriceSlider(priceRange, false);
    });

    var mobilePriceRanges = document.querySelectorAll('.collection-dynamic-filters__mobile-price-range');
    mobilePriceRanges.forEach(function(priceRange) {
      initPriceSlider(priceRange, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllPriceSliders, 100);
    });
  } else {
    setTimeout(initAllPriceSliders, 100);
  }

  document.addEventListener('collection:filtered', function() {
    setTimeout(initAllPriceSliders, 200);
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail && (
      event.detail.sectionId.includes('main-collection') || 
      event.detail.sectionId.includes('collection-template')
    )) {
      setTimeout(initAllPriceSliders, 200);
    }
  });
})();
